import layout from '@/views/layout/layout.vue'
const reportList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/list.vue')), 'group-wechatExcellent-report')
const newDealerList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/newDealer.vue')), 'group-wechatExcellent-newDealerreport')
const dealerOrderList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/dealerOrder.vue')), 'group-wechatExcellent-dealerOrder')
const recommendList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/recommend.vue')), 'group-wechatExcellent-recommend')
const tempBounList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/tempBoun.vue')), 'group-wechatExcellent-tempBoun')
const treeList = r => require.ensure([], () => r(require('@/views/wechatExcellent/report/treelist.vue')), 'group-wechatExcellent-treelist')
const report = [
  {
    path: '/wechatExcellent/report',
    name: 'wechatExcellent-report',
    component: layout,
    redirect: '/wechatExcellent/report/list',
    hidden: true,
    children: [
      {
        path: 'list',
        component: reportList,
        name: 'wechatExcellent-report-list',
        meta: {
          displayName: '业绩报表',
          requireAuth: true
        }
      },
      {
        path: 'newDealer',
        component: newDealerList,
        name: 'wechatExcellent-newdealerreport-list',
        meta: {
          displayName: '新增代理报表',
          requireAuth: true
        }
      },
      {
        path: 'dealerOrderList',
        component: dealerOrderList,
        name: 'wechatExcellent-dealerOrder-list',
        meta: {
          displayName: '经销商订单',
          requireAuth: true
        }
      },
      {
        path: 'recommend',
        component: recommendList,
        name: 'wechatExcellent-dealerOrder-recommendList',
        meta: {
          displayName: '股东推荐奖列表',
          requireAuth: true
        }
      },
      {
        path: 'tempBoun',
        component: tempBounList,
        name: 'wechatExcellent-dealerOrder-tempBoun',
        meta: {
          displayName: '股东推荐奖列表',
          requireAuth: true
        }
      },
      {
        path: 'treelist',
        component: treeList,
        name: 'wechatExcellent-dealerOrder-treelist',
        meta: {
          displayName: '王者奖励',
          requireAuth: true
        }
      }
    ]
  }
]

export default report



// WEBPACK FOOTER //
// ./src/router/wechatExcellent/report.js